export default "__VITE_ASSET__CiBzokJi__"